import routes from './routes';
import { SetRoutes } from 'components';

const CalendarCategoriesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default CalendarCategoriesPages;
